import { shape, string } from 'prop-types';

export const catalogTypeType = shape({
  id: string.isRequired,
  name: string.isRequired
});
